/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierPortalActivity
 */
export interface CarrierPortalActivity {
  /**
   *
   * @type {string}
   * @memberof CarrierPortalActivity
   */
  carrierPortalActivityId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPortalActivity
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPortalActivity
   */
  activityType?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPortalActivity
   */
  personName?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierPortalActivity
   */
  personEmail?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierPortalActivity
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierPortalActivity
   */
  detail?: string;
}

/**
 * Check if a given object implements the CarrierPortalActivity interface.
 */
export function instanceOfCarrierPortalActivity(
  value: object,
): value is CarrierPortalActivity {
  return true;
}

export function CarrierPortalActivityFromJSON(
  json: any,
): CarrierPortalActivity {
  return CarrierPortalActivityFromJSONTyped(json, false);
}

export function CarrierPortalActivityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierPortalActivity {
  if (json == null) {
    return json;
  }
  return {
    carrierPortalActivityId:
      json["carrierPortalActivityId"] == null
        ? undefined
        : json["carrierPortalActivityId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    activityType:
      json["activityType"] == null ? undefined : json["activityType"],
    personName: json["personName"] == null ? undefined : json["personName"],
    personEmail: json["personEmail"] == null ? undefined : json["personEmail"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    detail: json["detail"] == null ? undefined : json["detail"],
  };
}

export function CarrierPortalActivityToJSON(json: any): CarrierPortalActivity {
  return CarrierPortalActivityToJSONTyped(json, false);
}

export function CarrierPortalActivityToJSONTyped(
  value?: CarrierPortalActivity | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierPortalActivityId: value["carrierPortalActivityId"],
    carrierIdentifier: value["carrierIdentifier"],
    activityType: value["activityType"],
    personName: value["personName"],
    personEmail: value["personEmail"],
    createdAt: value["createdAt"],
    detail: value["detail"],
  };
}
